import { useEffect, useState } from 'react'
import { motion } from 'motion/react'
import { useNavigation } from '@/contexts/NavigationProvider'
import { useProgress, MAX_LIVES } from '@/contexts/ProgressProvider'
import { useShop } from '@/contexts/ShopProvider'
import { GameButton } from '@/components/ui/GameButton'
import { PixelIcon } from '@/components/ui/PixelIcon'

const REGEN_MS = 5 * 60 * 1000
const GEM_REFILL_COST = 20

export function NoLivesScreen() {
  const { go, back } = useNavigation()
  const { save, update, spendGems } = useProgress()
  const { adsConfigured, adsReady, showRewarded } = useShop()
  const [now, setNow] = useState(Date.now())

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(t)
  }, [])

  const nextIn = Math.max(0, REGEN_MS - (now - save.economy.livesUpdatedAt))
  const mins = Math.floor(nextIn / 60000)
  const secs = Math.floor((nextIn % 60000) / 1000)

  const refillFull = () =>
    update((s) => ({ ...s, economy: { ...s.economy, lives: MAX_LIVES, livesUpdatedAt: Date.now() } }))

  const buyWithGems = () => {
    if (spendGems(GEM_REFILL_COST)) refillFull()
  }

  const watchAd = async () => {
    const result = await showRewarded()
    if (result.status === 'watched') {
      update((s) => ({ ...s, economy: { ...s.economy, lives: s.economy.lives + 1, livesUpdatedAt: Date.now() } }))
    }
  }

  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 px-6 text-center">
      <motion.div
        initial={{ scale: 0.7, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="grid place-items-center w-20 h-20 rounded-full bg-[var(--surface-raised)] shadow-emboss"
        style={{ color: 'var(--danger)' }}
      >
        <PixelIcon name="heart" size={36} />
      </motion.div>

      <div>
        <h1 className="font-display text-2xl font-black">Out of Lives</h1>
        <p className="mt-1 text-[var(--text-dim)]">Next life in {mins}:{String(secs).padStart(2, '0')}</p>
      </div>

      <div className="flex flex-col gap-2 w-full max-w-xs">
        <GameButton size="lg" icon="gem" fullWidth disabled={save.economy.gems < GEM_REFILL_COST} onClick={buyWithGems}>
          Refill ({GEM_REFILL_COST} gems)
        </GameButton>
        {adsConfigured && adsReady && (
          <GameButton variant="secondary" icon="gift" fullWidth onClick={watchAd}>
            Watch Ad for +1 Life
          </GameButton>
        )}
        <div className="flex gap-2">
          <GameButton variant="ghost" icon="shop" fullWidth onClick={() => go('shop')}>
            Shop
          </GameButton>
          <GameButton variant="ghost" icon="levelSelect" fullWidth onClick={back}>
            Back
          </GameButton>
        </div>
      </div>
    </div>
  )
}
